import { useEffect, useState } from "react";
import useInterval from "lib/useInterval";
import axios from "axios";

export default function SlaCard(props) {
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);

  // ↓ move this to an API route
  async function getTicketsInView() {
    const url =
      "https://us-central1-festive1.cloudfunctions.net/getTicketsInView?view=sla";

    const { data } = await axios.get(url);
    setData(data);
  }

  useEffect(() => {
    getTicketsInView(props.view);
  }, [props.view]);

  useInterval(() => {
    getTicketsInView(props.view);
  }, 60000);

  let bootstrapProps;
  if (data.numOfTickets > 0) {
    bootstrapProps = "bg-danger text-white";
  } else {
    bootstrapProps = "text-secondary";
  }

  return (
    <>
      <div
        className={`card mb-4 shadow text-center ${bootstrapProps}`}
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={props.tooltip}
      >
        <h6 className={`card-header `}>
          {props.title ? props.title : props.view}
        </h6>
        <div className="card-body text-center">
          <h4 className="card-text">{data.numOfTickets}</h4>
        </div>
      </div>
    </>
  );
}
